var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEye = function SvgEye(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 21 15",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.106 8.645a2.222 2.222 0 1 0 0-4.445c-.034 0-.065.009-.099.01a1.648 1.648 0 0 1-2.113 2.113c0 .035-.01.066-.01.1a2.222 2.222 0 0 0 2.222 2.222Zm9.88-1.618c-1.884-3.674-5.611-6.16-9.88-6.16-4.268 0-7.997 2.487-9.879 6.16a1.123 1.123 0 0 0 0 1.013c1.883 3.674 5.61 6.16 9.88 6.16 4.268 0 7.996-2.487 9.878-6.16a1.122 1.122 0 0 0 0-1.013Zm-9.88-5.049a4.445 4.445 0 1 1 0 8.89 4.445 4.445 0 0 1 0-8.89Zm0 11.111c-3.728 0-7.134-2.129-8.889-5.555a10.235 10.235 0 0 1 4.507-4.491 5.505 5.505 0 0 0-1.173 3.38 5.556 5.556 0 1 0 11.11 0 5.504 5.504 0 0 0-1.172-3.38c1.94.98 3.52 2.553 4.506 4.49-1.754 3.427-5.161 5.556-8.889 5.556Z",
    className: "svgEye"
  })));
};
export default SvgEye;